import { Controller } from "@hotwired/stimulus"

// Live barcode preview for the public Barcode Generator tool. Points an <img>
// (and the download links) at the server barcode endpoint, which reuses the
// production BarcodeGeneratorService.
export default class extends Controller {
  static targets = [
    "value", "symbology", "image", "error",
    "downloadPng", "downloadSvg", "downloadPdf"
  ]
  static values = { endpoint: String }

  connect() {
    this.render()
  }

  // Debounced so typing doesn't fire a request per keystroke.
  refresh() {
    clearTimeout(this.debounce)
    this.debounce = setTimeout(() => this.render(), 250)
  }

  render() {
    const value = this.valueTarget.value.trim()
    const symbology = this.symbologyTarget.value

    if (!value) {
      this.imageTarget.removeAttribute("src")
      return
    }

    this.errorTarget.hidden = true
    this.imageTarget.hidden = false
    this.imageTarget.src = this.url(value, symbology, "png", false)
    this.downloadPngTarget.href = this.url(value, symbology, "png", true)
    this.downloadSvgTarget.href = this.url(value, symbology, "svg", true)
    this.downloadPdfTarget.href = this.url(value, symbology, "pdf", true)

    // SVG output is not available for QR codes.
    this.downloadSvgTarget.hidden = symbology === "qr"
  }

  imageError() {
    this.imageTarget.hidden = true
    this.errorTarget.hidden = false
  }

  url(value, symbology, format, download) {
    const params = new URLSearchParams({ value, symbology, format })
    if (download) params.set("download", "1")
    return `${this.endpointValue}?${params.toString()}`
  }
}
